

import {  Globe, Users, BookOpen, Home } from "lucide-react"


// Composant Button
// const Button = ({ children, variant = "default", className = "", onClick, ...props }) => {
//   const baseClasses =
//     "inline-flex items-center justify-center rounded-md text-sm font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none"
//   const variants = {
//     default: "bg-blue-600 text-white hover:bg-blue-700 h-10 px-4 py-2",
//     outline: "border border-gray-300 bg-white dark:bg-gray-800  hover:bg-gray-50 h-10 px-4 py-2",
//     ghost: "hover:bg-gray-100 text-gray-700 h-10 px-4 py-2",
//   }

//   return (
//     <button className={`${baseClasses} ${variants[variant]} ${className}`} onClick={onClick} {...props}>
//       {children}
//     </button>
//   )
// }

// Données de l'équipe
// const teamMembers = [
//   {
//     name: "Sophie Martin",
//     role: "Fondatrice & Directrice",
//     bio: "Ancienne étudiante internationale au Kenya, Sophie a créé cette plateforme pour aider les futurs étudiants à naviguer dans le système éducatif kenyan.",
//     image:
//       "https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-4.0.3&auto=format&fit=crop&w=256&q=80",
//   },
//   {
//     name: "David Kamau",
//     role: "Expert en Éducation",
//     bio: "Avec 15 ans d'expérience dans le système éducatif kenyan, David apporte une expertise locale inestimable à notre plateforme.",
//     image:
//       "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=256&q=80",
//   },
//   {
//     name: "Amina Ochieng",
//     role: "Spécialiste Logement",
//     bio: "Amina aide les étudiants à trouver le logement idéal à Nairobi et dans d'autres villes universitaires du Kenya.",
//     image:
//       "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?ixlib=rb-4.0.3&auto=format&fit=crop&w=256&q=80",
//   },
//   {
//     name: "Thomas Dubois",
//     role: "Conseiller Visa & Immigration",
//     bio: "Thomas guide les étudiants internationaux à travers les complexités des procédures de visa et d'immigration kenyanes.",
//     image:
//       "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-4.0.3&auto=format&fit=crop&w=256&q=80",
//   },
// ]

// Données des partenaires
// const partners = [
//   {
//     name: "University of Nairobi",
//     logo: "https://images.unsplash.com/photo-1562774053-701939374585?ixlib=rb-4.0.3&auto=format&fit=crop&w=120&q=80",
//   },
//   {
//     name: "Kenyatta University",
//     logo: "https://images.unsplash.com/photo-1523050854058-8df90110c9f1?ixlib=rb-4.0.3&auto=format&fit=crop&w=120&q=80",
//   },
//   {
//     name: "Strathmore University",
//     logo: "https://images.unsplash.com/photo-1498243691581-b145c3f54a5a?ixlib=rb-4.0.3&auto=format&fit=crop&w=120&q=80",
//   },
//   {
//     name: "USIU Africa",
//     logo: "https://images.unsplash.com/photo-1564981797816-1043664bf78d?ixlib=rb-4.0.3&auto=format&fit=crop&w=120&q=80",
//   },
// ]

function AboutUsPage({ onNavigate }) {
  return (
    <div className="min-h-screen bg-white dark:bg-gray-800 ">
      {/* Header */}
     

      {/* Hero Section */}
    

      {/* Notre mission */}
     
      {/* Nos Services */}
      <section className="py-16 dark:bg-gray-900 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold dark:text-gray-200 text-gray-900 mb-12 text-center">Nos Services</h2>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
            <div className="text-center">
              <div className="bg-green-100 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4">
                <BookOpen className="h-8 w-8 text-green-600" />
              </div>
              <h3 className="text-lg font-semibold mb-1 dark:text-gray-300 ">Informations Universitaires</h3>
              <p className="text-gray-600 dark:text-gray-400 text-sm">
                Base de données complète de toutes les universités kenyanes avec programmes, frais, et conditions
                d'admission.
              </p>
            </div>

            <div className="text-center">
              <div className="bg-blue-100 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4">
                <Home className="h-8 w-8 text-blue-600" />
              </div>
              <h3 className="text-lg font-semibold mb-1 dark:text-gray-300 ">Recherche de Logement</h3>
              <p className="text-gray-600 dark:text-gray-400 text-sm">
                Répertoire vérifié de logements étudiants avec photos, prix, et informations détaillées sur les
                commodités.
              </p>
            </div>

            <div className="text-center">
              <div className="bg-purple-100 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4">
                <Users className="h-8 w-8 text-purple-600" />
              </div>
              <h3 className="text-lg font-semibold mb-1 dark:text-gray-300 ">Accompagnement Personnalisé</h3>
              <p className="text-gray-600 dark:text-gray-400 text-sm">
                Consultations individuelles, aide aux candidatures, assistance visa, et suivi pendant tout votre
                parcours.
              </p>
            </div>

            <div className="text-center">
              <div className="bg-orange-100 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4">
                <Globe className="h-8 w-8 text-orange-600" />
              </div>
              <h3 className="text-lg font-semibold mb-1 dark:text-gray-300 ">Support Continu</h3>
              <p className="text-gray-600 dark:text-gray-400 text-sm">
                Assistance 7j/7, guides pratiques, conseils d'intégration, et communauté d'étudiants internationaux.
              </p>
            </div>
          </div>

          {/* Témoignages détaillés */}
          {/* <div className="bg-white dark:bg-gray-800  rounded-xl p-8 shadow-lg">
            <h3 className="text-2xl font-bold text-gray-900 mb-8 text-center">Ce que disent nos étudiants</h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="text-center">
                <div className="mb-4">
                  <img
                    src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-4.0.3&auto=format&fit=crop&w=150&q=80"
                    alt="Marie"
                    className="w-20 h-20 rounded-full mx-auto object-cover"
                  />
                </div>
                <blockquote className="text-gray-600 italic mb-4">
                  "Grâce à Études au Kenya, j'ai pu naviguer facilement dans toutes les démarches. Leur guide était
                  extrêmement détaillé et leur support client exceptionnel."
                </blockquote>
                <div className="font-semibold">Marie Dubois</div>
                <div className="text-sm text-gray-500">Étudiante en Médecine, University of Nairobi</div>
              </div>

              <div className="text-center">
                <div className="mb-4">
                  <img
                    src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=150&q=80"
                    alt="Jean"
                    className="w-20 h-20 rounded-full mx-auto object-cover"
                  />
                </div>
                <blockquote className="text-gray-600 italic mb-4">
                  "Le service de recherche de logement m'a fait économiser des semaines de recherche. J'ai trouvé
                  l'appartement parfait avant même d'arriver à Nairobi."
                </blockquote>
                <div className="font-semibold">Jean Mukendi</div>
                <div className="text-sm text-gray-500">Étudiant en Ingénierie, JKUAT</div>
              </div>

              <div className="text-center">
                <div className="mb-4">
                  <img
                    src="https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?ixlib=rb-4.0.3&auto=format&fit=crop&w=150&q=80"
                    alt="Amina"
                    className="w-20 h-20 rounded-full mx-auto object-cover"
                  />
                </div>
                <blockquote className="text-gray-600 italic mb-4">
                  "L'accompagnement personnalisé a fait toute la différence. Ils m'ont aidée à choisir la bonne
                  université et le bon programme selon mes objectifs de carrière."
                </blockquote>
                <div className="font-semibold">Amina Hassan</div>
                <div className="text-sm text-gray-500">Étudiante en Business, Strathmore University</div>
              </div>
            </div>
          </div> */}
        </div>
      </section>

      {/* Notre Processus */}

      {/* Notre histoire */}
     

      {/* Notre équipe */}
    
      {/* FAQ Section */}
      <section className="dark:bg-gray-900 py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-2xl font-bold dark:text-gray-100 text-gray-900 mb-12 text-center">Questions Fréquemment Posées</h2>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            {/* Questions générales */}
            <div className="space-y-6">
              <h3 className="text-xl font-semibold text-green-600 mb-4">Questions Générales</h3>

              <div className="bg-white dark:bg-gray-800  p-2 rounded-lg shadow-sm border-l-4 border-green-500">
                <h4 className="font-semibold text-gray-900 mb-1 dark:text-gray-300 ">Qu'est-ce qu'Études au Kenya ?</h4>
                <p className="text-gray-600">
                 
                </p>
              </div>

              <div className="bg-white dark:bg-gray-800  p-2 rounded-lg shadow-sm border-l-4 border-green-500">
                <h4 className="font-semibold text-gray-900 mb-1 dark:text-gray-300 ">Nos services sont-ils gratuits ?</h4>
                <p className="text-gray-600">
                  
                </p>
              </div>

              <div className="bg-white dark:bg-gray-800  p-2 rounded-lg shadow-sm border-l-4 border-green-500">
                <h4 className="font-semibold text-gray-900 mb-1 dark:text-gray-300 ">Dans quelles langues offrez-vous vos services ?</h4>
                <p className="text-gray-600">
                 
                </p>
              </div>

              <div className="bg-white dark:bg-gray-800  p-2 rounded-lg shadow-sm border-l-4 border-green-500">
                <h4 className="font-semibold text-gray-900 mb-1 dark:text-gray-300 ">
                  Combien de temps à l'avance dois-je commencer mes démarches ?
                </h4>
                <p className="text-gray-600">
                 
                </p>
              </div>
            </div>

            {/* Questions techniques */}
            <div className="space-y-6">
              <h3 className="text-xl font-semibold text-blue-600 mb-4">Études et Admissions</h3>

              <div className="bg-white dark:bg-gray-800  p-2 rounded-lg shadow-sm border-l-4 border-blue-500">
                <h4 className="font-semibold text-gray-900 mb-1 dark:text-gray-300 ">
                  Quelles sont les conditions d'admission dans les universités kenyanes ?
                </h4>
                <p className="text-gray-600">
             
                </p>
              </div>

              <div className="bg-white dark:bg-gray-800  p-2 rounded-lg shadow-sm border-l-4 border-blue-500">
                <h4 className="font-semibold text-gray-900 mb-1 dark:text-gray-300 ">Combien coûtent les études au Kenya ?</h4>
                <p className="text-gray-600">
                  
                </p>
              </div>

              <div className="bg-white dark:bg-gray-800  p-2 rounded-lg shadow-sm border-l-4 border-blue-500">
                <h4 className="font-semibold text-gray-900 mb-1 dark:text-gray-300 ">Puis-je travailler pendant mes études ?</h4>
                <p className="text-gray-600">
                  
                </p>
              </div>

              <div className="bg-white dark:bg-gray-800  p-2 rounded-lg shadow-sm border-l-4 border-blue-500">
                <h4 className="font-semibold text-gray-900 mb-1 dark:text-gray-300 ">Y a-t-il des bourses disponibles ?</h4>
                <p className="text-gray-600">
              
                </p>
              </div>
            </div>
          </div>

         {/* CTA */}
      <section className=" mt-20 bgC reveal dark:bg-gray-800 mb-10 from-green-600 rounded-lg to-blue-600 text-white">
        <div className="h-2 rounded-b rounded-full w-full bg-gradient-to-r from-pink-500 via-orange-400 to-yellow-400"></div>
        <div className="max-w-7xl py-16 mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-2xl font-bold mb-6">Trouvez Des Reponses </h2>
          <p className="text-xl mb-8 max-w-3xl mx-auto">
            Explorez nos ressources complètes et préparez-vous pour une expérience d'études inoubliable.
          </p>
          <div className="flex  flex-wrap justify-center gap-4">
            <a href="/mksp/guide/university"
              
              
              className="bg-gray-900 rounded border dark:bg-green-700 dark:text-gray-100 text-gray-100 hover:bg-green-700 text-base px-8 py-3 h-auto"
            >
              Explorer les universités
            </a>
            <a href="/mksp/guide"
              
              
              className="border-white bg-green-700 rounded dark:bg-green-700 dark:text-gray-100 text-white hover:bg-green-500 text-base px-8 py-3 h-auto"
            >
              Consulter le guide premium
            </a>
          </div>
        </div>
      </section>
        

          {/* Section contact support */}
          {/* <div className="mt-12 bgC bg-gradient-to-r from-green-100 to-blue-100 rounded-xl p-8 text-center">
            <h3 className="text-xl font-semibold text-green-500 mb-4">Vous ne trouvez pas votre réponse ?</h3>
            <p className="text-gray-200  mb-6">
              Notre équipe de support est disponible pour répondre à toutes vos questions spécifiques.
            </p>
            <div className="flex flex-wrap justify-center gap-4">
              <Button variant="default">
                <Mail className="h-4 w-4 mr-2" />
                Nous contacter
              </Button>
              <Button variant="outline">
                <Phone className="h-4 w-4 mr-2" />
                Planifier un appel
              </Button>
            </div>
          </div> */}
        </div>
      </section>

      {/* Nos partenaires */}
     

      {/* Contactez-nous */}
      

      {/* Footer */}
      
    </div>
  )
}

export default AboutUsPage
